import React, {useState, Suspense} from "react";
import {BrowserRouter, Routes, Route, Navigate} from 'react-router-dom';

import {venifyRoot, veneshRoot} from "./tools/urls"
import AuthContext from "./tools/contexts/AuthContext";
import LoadingScreen from "./components/LoadingScreen";
import AppContext from "./tools/contexts/AppContext";
import Error from "./pages/Error"
import CarOriginality from "./pages/carOriginality/CarOriginality";
import GetDeposits from "./pages/tosan/GetDeposits";
import StartAuth from "./pages/StartAuth";
import IAuthReports from "./pages/reports/IAuthReports";
import EstateOriginality from "./pages/estateOriginality/EstateOriginality";
import CServiceReports from "./pages/reports/CServiceReports";
import EstateReports from "./pages/reports/EstateReports";
import Authentication from "./pages/authentication/Authentication";
import AuthenticationPaymentInquiry from "./pages/authentication/PaymentInquiry";
import AuthenticationReports from "./pages/reports/AuthenticationReports";
import UserAuthentication from "./pages/authentication/UserAuthentication";
import ReportLayout from "./pages/reports/ReportLayout";
import ForeignerAuth from "./pages/authentication/ForeignerAuth";
import AccessDenied from "./pages/AccessDenied";
import PaymentReceipt from "./pages/tosan/PaymentReceipt";
import TransactionalCredit from "./pages/transactionalCredit/TransactionalCredit";
import OriginalityDevice from "./pages/originalityDevice/OriginalityDevice";
import TransactionalCreditReports from "./pages/reports/TransactionalCreditReports";
import OriginalityDeviceReports from "./pages/reports/OriginalityDeviceReports";
import DivarInternalCar from "./pages/divarInternalCar/DivarInternalCar";
import TosanLayout from "./components/layouts/tosan/TosanLayout";
import BillServices from "./pages/tosan/BillServices";
import BillList from "./pages/tosan/BillList";
import AddNewBill from "./pages/tosan/AddNewBill";
import BillDetail from "./pages/tosan/BillDetail";
import GlobalLayout from "./components/layouts/GlobalLayout";
import TosanAccessDenied from "./pages/tosan/TosanAccessDenied";
import DivarInternalAuthReports from "./pages/reports/DivarInternalAuthReports";
import DivarPosts from "./pages/posts/DivarPosts";
import Gate from "./pages/Gate";
import DivarInternalEstate from "./pages/divarInternalEstate/DivarInternalEstate";
import FinCheck from "./pages/finCheck/FinCheck";
import FinCheckReports from "./pages/reports/FinCheckReports";
import CompanyApproval from "./pages/companyApproval/CompanyApproval";
import CompanyApprovalReports from "./pages/reports/CompanyApprovalReports";
import DivarInternalCarReports from "./pages/reports/DivarInternalCarReports";
import AuthenticatedRouteLayout from "./components/AuthenticatedRouteLayout";
import PrivacyPolicy from "./pages/Policy/PrivacyPolicy";
import TermsPage from "./pages/Policy/Terms";


const App = () => {
    const [user, setUser] = useState(JSON.parse(localStorage.getItem("user")) || null);
    const [loading, setLoading] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState('')
    const [step, setStep] = useState(1);
    const [isLoginBase, setLoginBase] = useState(!!localStorage.getItem("login"));
    const NotFound = React.lazy(() => import('./pages/NotFound'));
    const PaymentInquiry = React.lazy(() => import('./pages/PaymentInquiry'));
    const handleStep = (step) => {
        setStep(step)
    }
    const handleLogin = (data, loginBaseEnter) => {
        if (loginBaseEnter) {
            localStorage.setItem('login', "1")
            setLoginBase(true)
        } else {
            localStorage.removeItem("login")
            setLoginBase(false)
        }
        localStorage.setItem('user', JSON.stringify(data))
        setUser({...data});

    }
    const handleLogOut = () => {
        setUser(null);
        localStorage.removeItem('user');


    }

    const handleLoading = (value, msg = '') => {

        if (!value) {
            setLoading(value);
            setLoadingMessage('')
        } else {
            setLoading(value);
            if (msg && msg.length)
                setLoadingMessage(msg)
        }

    }
    return <AppContext.Provider value={{
        isLoading: loading,
        handleLoading: handleLoading,
        step: step,
        handleStep: handleStep,
        loadingMessage: loadingMessage,

    }}>
        <AuthContext.Provider value={{
            authenticated: !!user,
            user: user,
            login: handleLogin,
            logout: handleLogOut,
            isLoginBase: isLoginBase,
        }}>
            {loading && <LoadingScreen text={loadingMessage}/>}
            <BrowserRouter basename="/">
                <Routes>
                    <Route element={<GlobalLayout/>}>

                        <Route exact path={`/privacyPolicy`} element={<PrivacyPolicy/>}/>
                        <Route exact path={`/terms`} element={<TermsPage/>}/>
                        <Route exact path={`/auth/gate/:id/:service`} element={<Gate/>}/>
                        <Route exact path={`/auth/start/:id/:service`} element={<StartAuth/>}/>
                        <Route path={`/Reports`} element={<ReportLayout/>}>
                            <Route path="IAuth" element={<IAuthReports/>}/>
                            <Route path="CService" element={<CServiceReports/>}/>
                            <Route path="Estate" element={<EstateReports/>}/>
                            <Route path="Authentications" element={<AuthenticationReports/>}/>
                            <Route path="OriginalityDevice" element={<OriginalityDeviceReports/>}/>
                            <Route path="TransactionalCredit" element={<TransactionalCreditReports/>}/>
                            <Route path="DivarInternalAuth" element={<DivarInternalAuthReports/>}/>
                            <Route path="FinCheck" element={<FinCheckReports/>}/>
                            <Route path="CompanyApproval" element={<CompanyApprovalReports/>}/>
                            <Route path="DivarInternalCar" element={<DivarInternalCarReports/>}/>
                        </Route>
                        <Route path="/" element={<AuthenticatedRouteLayout/>}>
                            <Route index element={<Navigate to={'/404'}/>}/>
                            <Route exact path={`/paymentInquiry`}
                                   element={<Suspense fallback={<LoadingScreen/>}><PaymentInquiry/></Suspense>}/>
                            <Route path={`/${veneshRoot}/CService`} element={<CarOriginality/>}/>
                            <Route path={`/${venifyRoot}/EstateOriginality`} element={<EstateOriginality/>}/>
                            <Route path={`/DivarInternalEstate`} element={<DivarInternalEstate/>}/>
                            <Route path={'/divarInternalCar'} element={<DivarInternalCar/>}/>
                            <Route path={`/authentications`}>
                                <Route index element={<Authentication/>}/>
                                <Route path={`userAuthentication`} element={<UserAuthentication/>}/>
                                <Route path="ForeignerAuth" element={<ForeignerAuth/>}/>
                                <Route path="paymentInquiry" element={<Suspense fallback={<LoadingScreen/>}><PaymentInquiry/></Suspense>}/>
                            </Route>
                            <Route path={`/transactionalCredit`} element={<TransactionalCredit/>}/>
                            <Route path="/posts" element={<DivarPosts/>}/>
                            <Route path="/finCheck" element={<FinCheck/>}/>
                            <Route path={`/originalityDevice`} element={<OriginalityDevice/>}/>
                            <Route path={'/companyApproval'} element={<CompanyApproval/>}/>
                        </Route>

                    </Route>
                    <Route path={'/tosan/'} element={<TosanLayout/>}>
                        <Route exact index element={<BillServices/>}/>
                        <Route path=":serviceType" exact element={<BillList/>}/>
                        <Route path="addBill">
                            <Route path=":serviceType" element={<AddNewBill/>}/>
                        </Route>
                        <Route path="bill">
                            <Route index element={<BillDetail/>}/>
                        </Route>
                        <Route path="getDeposits" element={<GetDeposits/>}/>
                        <Route path="paymentReceipt" element={<PaymentReceipt/>}/>
                        <Route path="accessDenied" element={<TosanAccessDenied/>}/>
                    </Route>
                    <Route path="/AccessDenied" element={<AccessDenied/>}/>
                    <Route exact path={`/Failed`} element={<Error/>}/>
                    <Route path="*" element={<Suspense fallback={<LoadingScreen/>}><NotFound/> </Suspense>}/>
                </Routes>
            </BrowserRouter>


        </AuthContext.Provider>
    </AppContext.Provider>

}
export default App;